import { render, staticRenderFns } from "./RequestProcess.vue?vue&type=template&id=3223f544&scoped=true&"
import script from "./RequestProcess.vue?vue&type=script&lang=js&"
export * from "./RequestProcess.vue?vue&type=script&lang=js&"
import style0 from "./RequestProcess.vue?vue&type=style&index=0&id=3223f544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3223f544",
  null
  
)

export default component.exports